/**
 * ConfettiSystem - Celebration particle effects
 */

import { useEffect, useState } from 'react';
import './ConfettiSystem.css';

const EMOJIS = ['⭐', '✨', '🌟', '💫', '🎉', '🎊', '🥳', '💖'];

export default function ConfettiSystem({ count = 25, duration = 4000 }) {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    // Generate particles
    const newParticles = [...Array(count)].map((_, i) => ({
      id: i,
      emoji: EMOJIS[Math.floor(Math.random() * EMOJIS.length)],
      left: Math.random() * 100,
      delay: Math.random() * 0.5,
      duration: 2 + Math.random() * 2,
      size: 16 + Math.random() * 16,
      wobble: Math.random() * 30 - 15,
    }));
    
    setParticles(newParticles);

    // Cleanup after duration
    const timer = setTimeout(() => {
      setParticles([]);
    }, duration);

    return () => clearTimeout(timer);
  }, [count, duration]);

  if (particles.length === 0) return null;

  return (
    <div className="confetti">
      {particles.map(p => (
        <div
          key={p.id}
          className="confetti__particle"
          style={{
            left: `${p.left}%`,
            fontSize: `${p.size}px`,
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.duration}s`,
            '--wobble': `${p.wobble}px`,
          }}
        >
          {p.emoji}
        </div>
      ))}
    </div>
  );
}
